import connectTransport from "../connect"
import FromHkustPage from "./FromHkustPage"

export default connectTransport(FromHkustPage)
